import(/* webpackMode: "eager" */ "/app/src/app/(frontend)/login/page.tsx");
